import { render, staticRenderFns } from "./RealNameAuthentication.vue?vue&type=template&id=68899a32&scoped=true&"
import script from "./RealNameAuthentication.vue?vue&type=script&lang=js&"
export * from "./RealNameAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./RealNameAuthentication.vue?vue&type=style&index=0&id=68899a32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68899a32",
  null
  
)

export default component.exports